import "../chunk-PKUHTIDK.js";
const api = ["state"];
const renderless = (props, { reactive, inject, computed }) => {
  const tabs = inject("tabs", null);
  const state = reactive({
    navItems: computed(() => tabs.state.items)
  });
  return { state };
};
export {
  api,
  renderless
};
